export default "__VITE_ASSET__CRl3wxth__"